import React, { useState } from 'react';
import { getDirection, pexios, toast } from '../../../utils/functions';
import { history } from '../../../utils/variables';
import Modal from '../../master/Modal';
import addImage from '../../../assets/images/AddImagePlaceholder/addImage.png';
// import addImage from '../../../assets/images/add_image.png';
import HeaderIcon from '../../../assets/images/header-icon/video.png'
import Camera360 from '../../../assets/images/register-principles/carCamera.png';
import Limitation from '../../../assets/images/register-principles/20_limitation.png';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';


export default function RegisterVideo({ registerId, type = 'user'}) {

    const { t, i18n } = useTranslation();
    const {routerData} = useSelector(store=>store)

    // const [video, setVideo] = useState(false);
    const [showLoader, setShowLoader] = useState(false);

    function uploadVideo(video) {
        setShowLoader(true);
        let fd = new FormData();
        fd.append('id', routerData.id);
        fd.append('video', video.files[0]);
        pexios('api/upload_register_movie','post', fd,true)
            .then(()=>{
                setShowLoader(false);
                // setVideo(true);
                history.push('/register-pricing')
                // history.push('/')
                // toast('پرونده صدور شما با موفقیت تشکیل شد.باتشکر از همکاری شما.');
            })
            .catch(() => {
                toast(t('Error upload video alert'), 'error');
                setShowLoader(false);
            });

    }

    // function submit() {
    //     if (video) {
    //         toast(t('Successful upload video alert'));
    //         setTimeout(() => {
    //             history.replace('/')
    //         }, 5000);
    //     } else toast(t('Upload video is required'), 'error');
    // }

    return (
        <div className='register content'>
            <Modal visible={showLoader}>
                <div className='loader-modal'>
                    <p>{t('Uploading video')}</p>
                    <i className='fas fa-spinner fa-spin' />
                </div>
            </Modal>
            {/* <div className='mt20' style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}> */}
            <div className='title-image'>
                <img src={HeaderIcon} alt="icon"/>
            </div>
            <p className='guide-text m10'>
            لطفا یک ویدیو از خودرو با رعایت نکات زیر بار گذاری نمایید.          
             </p>
             <div className='register-principles mt30'>
             <div className={`d-flex align-items-center principle ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                <p>{t('Register modal 4-clause')}</p>
                <img src={Camera360} alt="camera"/>
            </div>
            <div className={`d-flex align-items-center principle ${getDirection(i18n.language) === 'leftToRight' ? 'flex-row-reverse': ''}`}>
                <p>حداکثر زمان تصویربرداری 20 ثانیه می باشد</p>
                <img src={Limitation} alt="camera"/>
            </div>
             </div>
            <div className='register-complete-img mt20' style={{alignItems:'flex-end',width: '95%'}}>
                {/* <p className='upload-text'>{t('20 seconds video')}</p> */}
                {/* {
                    video ?
                        <div className='imageBox'><i className='fas fa-check' style={{color:'green',fontSize:70,marginTop:10}} /></div> :
                        <label className='imageBox'>
                            <img
                                src={addImage}
                                style={{width: 70, height: 70,marginTop:10}}
                                alt='images'
                            />
                            <input
                                type='file'
                                accept='video/*'
                                capture='camera'
                                style={{display:'none'}}
                                onChange={(e) => uploadVideo(e.target)}
                            />
                        </label>
                } */}
            </div>
            {
                // type === 'user' &&

                <div className='d-flex justify-center mt20'>
                    {/* <button className='btn btn-white-purple btn-circle w-50'>
                        شروع فیلمبرداری
                    </button> */}
                    <Link to='/register-pricing' className='btn btn-white-purple w-50 btn-circle mx10'>
                        {t('Next step')}
                    </Link>
                    <label className='btn btn-white-purple btn-circle w-50 mx10'>
                        شروع فیلمبرداری
                        <input
                            type='file'
                            accept='video/*'
                            capture='camera'
                            style={{display:'none'}}
                            onChange={(e) => uploadVideo(e.target)}
                        />
                    </label>
                </div>
            }
        </div>
    );

}
